import React from 'react'
import styled from 'styled-components'
import { useCtaText } from 'src/modules/hooks/useCtaText'
import { useSelector } from 'react-redux'
import { selectCTAParams } from 'src/modules/reducers/params'
import { defaultCTAURI } from 'src/modules/utils/constants'
import { createUrl } from 'src/modules/utils/createUrl'
import { replaceUrlParam } from 'src/modules/utils/replaceUrlParam'

const CompareButton = ({ href, label, offerCode }) => {
  const ctaCopy = useCtaText({ lang: 'en', market: 'us', isTextShort: true, ctaText: label })
  const parsedParams = useSelector(selectCTAParams)

  let ctaURL = href
  if (!ctaURL && offerCode) {
    // Build CTA URL with offer code preselection
    ctaURL = createUrl(defaultCTAURI, parsedParams)
    ctaURL = replaceUrlParam(ctaURL, 'offer', offerCode)
    ctaURL = replaceUrlParam(ctaURL, 'comp', 'general-compare')
  } else if (!ctaURL) {
    ctaURL = 'https://www.fubo.tv/signup'
  }

  return (
    <StyledCompareButton href={ctaURL}>
      <span>{ctaCopy}</span>
    </StyledCompareButton>
  )
}

export default CompareButton

const StyledCompareButton = styled.a`
  background: #e03100;
  border-radius: 82.8795px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6.63036px 13.2607px;
  gap: 6.63px;

  width: 150.84px;
  height: 36.47px;

  span {
    /* Label/Label-L (Bold) */

    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    /* or 125% */

    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.01em;

    /* _/White */

    color: #ffffff;
  }
`
